(function(){
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(reduced){
    root.classList.add('motion-failsafe');
    document.querySelectorAll('.r,.rs,.ph,.motion-section').forEach(function(el){
      el.classList.add('in','is-visible');
    });
  }

  var drawer = document.getElementById('dw');
  var burger = document.getElementById('burg');

  function syncDrawer(){
    if(!drawer || !burger) return;
    var open = drawer.classList.contains('open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('drawer-open', open);
  }

  if(drawer && burger){
    new MutationObserver(syncDrawer).observe(drawer, {attributes:true, attributeFilter:['class']});
    burger.addEventListener('click', function(){
      setTimeout(function(){
        syncDrawer();
        if(drawer.classList.contains('open')){
          var close = drawer.querySelector('.dw__cl');
          if(close) close.focus();
        }
      }, 0);
    });

    drawer.querySelectorAll('[data-x]').forEach(function(button){
      button.addEventListener('click', function(){
        setTimeout(function(){
          syncDrawer();
          if(burger) burger.focus();
        }, 0);
      });
    });

    drawer.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        if(drawer.classList.contains('open')){
          drawer.classList.remove('open');
          document.body.style.overflow = '';
          syncDrawer();
        }
      });
    });

    syncDrawer();
  }

  document.querySelectorAll('.acc__h').forEach(function(button){
    button.addEventListener('click', function(){
      setTimeout(function(){
        button.setAttribute('aria-expanded', button.parentElement.classList.contains('open') ? 'true' : 'false');
      }, 0);
    });
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape' && drawer && drawer.classList.contains('open')){
      drawer.classList.remove('open');
      document.body.style.overflow = '';
      syncDrawer();
      if(burger) burger.focus();
    }
  });

  document.querySelectorAll('a[target="_blank"]').forEach(function(link){
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if(rel.indexOf('noopener') === -1) rel.push('noopener');
    link.setAttribute('rel', rel.join(' '));
  });
})();
